import React from 'react';
import '../../Styles/theme/PasswordModel.css';
import keyimage from '../../Images/Icons/key.png';

const PasswordModal = ({
  visible,
  password,
  onPasswordChange,
  onSetPassword,
  onSkipPassword,
  onCancel
}) => {
  if (!visible) return null;
  
  return (
    <div className="model-overlay" onClick={(e) => {e.stopPropagation(); onCancel();}}>
      <div className="model" onClick={(e) => e.stopPropagation()} >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '10px' }}>
          <img
            src={keyimage}
            alt="Modal"
            style={{ width: '50px', height: '50px' }}
          />
        </div>
        <p style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '5px' }}>
          <strong>是否設定密碼?</strong>
        </p>
        <p style={{ fontSize: '15px', marginTop: '7px' }}>
          為本次的分享設定一組密碼，並由系統協助您保存。
        </p>
        <p style={{ fontSize: '15px' }}>
          您可在寄送證書時，隨信附上密碼，供收件人輸入查看詳細內容。
        </p>
        <p className="reminder" style={{ marginTop: '15px', fontSize: '14px' }}>
          提醒您，如要修改密碼，請關閉分享再重新啟用分享。
        </p>
        <input
          type="password"
          placeholder="密碼"
          value={password}
          onChange={(e) => onPasswordChange(e.target.value)}
          style={{ marginTop: '5px' }}
        />
        <p style={{ fontSize: '13px', color: '#999' }}>請輸入8到20碼英文或數字</p>
        <div className="button-group">
          <button 
            onClick={onSkipPassword}
            style={{ 
              padding: '5px 10px', 
              margin: '5px', 
              background: 'white', 
              color: '#1C734A',
              border: '1px solid #1C734A',
              fontSize: '15px'
            }}
          >
            不設定直接啟用
          </button>
          <button 
            onClick={onSetPassword}
            style={{ 
              padding: '5px 10px', 
              margin: '5px', 
              background: '#1C734A', 
              color: 'white',
              border: '1px solid #1C734A',
              fontSize: '15px'
            }}
          >
            設定密碼
          </button>
          <button 
            onClick={onCancel}
            style={{ 
              padding: '5px 10px', 
              margin: '5px', 
              background: 'white', 
              color: '#888',
              border: '1px solid #888',
              fontSize: '15px'
            }}
          >
            取消
          </button>
        </div>
      </div>
    </div>
  );
};

export default PasswordModal;
